import React from 'react'
import DashboardTable from '../DashboardTable.component'
import { collectionsPPData } from '../DashboardMockData'
import { formatNumber, computeIncome } from '@utils/index'
import { Data, roleTemplate, simpleColTemplate } from './Production.component'

function Collections(): React.ReactElement {
  const totalCollections = (field: string): number => {
    return collectionsPPData.reduce(
      (acc: number, item: any) => acc + item[field],
      0,
    )
  }

  const collectionColTemplate = (datum: Data): React.ReactElement => {
    const income = computeIncome(datum.collections, datum.prevCollections)
    const isIncomeDown = income < 1
    return (
      <>
        <div className="mb-2">Collections</div>
        <div className="fs-1 mb-2">{formatNumber(datum.collections, true)}</div>
        <div>
          <i
            className={`bi ${
              isIncomeDown
                ? 'bi-arrow-down-circle-fill'
                : 'bi-arrow-up-circle-fill'
            } me-1`}
          ></i>
          {`${isIncomeDown ? 'Down' : 'Up'} ${Math.abs(income).toFixed(0)}% from the previous week`}
        </div>
      </>
    )
  }

  const columns = [
    {
      field: 'role',
      header: 'Provider Totals',
      template: roleTemplate,
      width: '100',
    },
    {
      field: 'collections',
      header: 'Collections',
      template: collectionColTemplate,
      headerTemplate: () =>
        simpleColTemplate('Collections', totalCollections('collections'), '$'),
      width: '200',
    },
    {
      field: 'insurance',
      header: 'Insurance',
      template: (datum: Data) =>
        simpleColTemplate('Insurance', datum.insurance, '$'),
      headerTemplate: () =>
        simpleColTemplate('Insurance', totalCollections('insurance'), '$'),
      width: '100',
    },
    {
      field: 'patients',
      header: 'Patients',
      template: (datum: Data) =>
        simpleColTemplate('Patients', datum.patients, '$'),
      headerTemplate: () =>
        simpleColTemplate('Patients', totalCollections('patients'), '$'),
      width: '150',
    },
  ]

  return (
    <div>
      <DashboardTable
        title="Collection"
        columns={columns}
        data={collectionsPPData}
        allowMultiSorting={false}
        allowSorting={false}
      />
    </div>
  )
}

export default Collections
